import React, { useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Card, Typography, Button, Box, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "../../../constants/colors";
import RadioCustom from "../../../components/radio/RadioCustom";
import { advisorFormApi } from "../../../api/advisor-form/advisor-form.api";
import { advisorEstimateApi } from "../../../api/advisor-estimate/advisor-estimate.api";
import { unsetLoading } from "../../../store/loading/loading.slice";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { advisorStudentApi } from "../../../api/advisor-student/advisor-student.api";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Collapse from "@mui/material/Collapse"; // Import Collapse for transition
import InputTextField from "../../../components/input/inputTextField";
import { useTranslation } from "react-i18next";

interface DataChoice {
  label: string;
  value: string;
}

const dataChoices: DataChoice[] = [
  { label: "ดีมาก", value: "ดีมาก" }, // i18n-ignore (value is data; label translated at render site)
  { label: "ดี", value: "ดี" }, // i18n-ignore (value is data; label translated at render site)
  { label: "ปานกลาง", value: "ปานกลาง" }, // i18n-ignore (value is data; label translated at render site)
  { label: "ควรปรับปรุง", value: "ควรปรับปรุง" }, // i18n-ignore (value is data; label translated at render site)
];

interface AdvisorEstimateDetail {
  id_advisor_estimate_detail: number;
  id_advisor_estimate: number;
  id_advisor_form_detail: number;
  id_advisor_form_detail_sub: number;
  estimate_point: string;
  status: string;
}

const VotingEvaluation = ({ id, isAll, token }: { id: number; isAll?: boolean, token?: string }) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);

  const [isContentVisible, setIsContentVisible] = React.useState(true);

  const chatContainerRef = React.useRef<HTMLDivElement | null>(null);

  // Toggle the visibility of card content
  const handleToggleContent = () => {
    setIsContentVisible(!isContentVisible);
  };

  const [dataEvaluationForm, setDataEvaluationForm] = useState<any[]>([]);
  const [selectedValues, setSelectedValues] = useState<any>({}); // Nested state to track selected values by detail and sub-detail ID
  const [singleData, setSingleData] = useState<any>({});
  const [remark, setRemark] = useState<string>("");

  const getSingleDataConsultation = async (id: number) => {
    const res = await advisorStudentApi.getAdvisorStudentById(id);
    const data = res.data;
    if (data.status < 300) {
      let parsedAdvisorStudentDetail = {} as any;
      try {
        parsedAdvisorStudentDetail = JSON.parse(
          data?.data.advisor_student_detaill
        );
      } catch (error) {
        console.error("Error parsing advisor_student_detaill:", error);
      }
      setSingleData(parsedAdvisorStudentDetail);
    }
  };

  const getSingleEvaluationForm = async (id: number, token?:string) => {
    const res = await advisorFormApi.getAdvisorFormById(id, token);
    const data = res.data;
    if (data.status < 300) {
      return data.data;
    }
  };

  const fetchGetDataEvaluationFormById = async (id: number, token?: string) => {
    const res = await advisorEstimateApi.getEstimateById(id, token);
    const data = res.data;

    if (data.status < 300) {
      if (data.data.id_advisor_form) {
        const structureForm = await getSingleEvaluationForm(
          data.data.id_advisor_form,
          token
        );

        console.log("structureForm", structureForm);
        if (structureForm) {
          // Setting the evaluation form data
          setDataEvaluationForm(structureForm?.advisor_form_detail ?? []);

          setRemark(data.data?.remark ?? "");
          // Transform the structure to your save format
          const transformedData = {
            id_advisor_estimate: data.data.id_advisor_estimate,
            id_advisor_student: +id,
            remark: "string", // You may want to set this from your context
            status: "active", // Set appropriate status
            advisor_estimate_detail:
              data.data?.advisor_estimate_detail &&
              data.data?.advisor_estimate_detail.map((detail: any) => {
                return {
                  id_advisor_estimate_detail: detail.id_advisor_estimate_detail,
                  id_advisor_estimate: detail.id_advisor_estimate,
                  id_advisor_form_detail: detail.id_advisor_form_detail,
                  id_advisor_form_detail_sub: detail.id_advisor_form_detail_sub,
                  estimate_point: detail.estimate_point ?? null,
                  status: detail.status,
                };
              }),
          };

          console.log("Transformed Data:", transformedData);
          setSelectedValues(transformedData);
          // You can now use transformedData for saving
        }
      } else {
        setDataEvaluationForm([]);
        setSelectedValues({}); // Reset selected values if no data
      }
    } else {
      // Handle error response
      console.error("Failed to fetch data:", data.status);
    }
  };

  useEffect(() => {
    if (id) {
      if (token){
        fetchGetDataEvaluationFormById(+id, token);
      } else {
        fetchGetDataEvaluationFormById(+id);
      }
    }
  }, [id, token]);

  // const updateEstimatePoint = (id: number, newEstimatePoint: string) => {
  //   setDataEvaluationForm((prevData) =>
  //     prevData.map((item) =>
  //       item.id_advisor_estimate_detail === id
  //         ? { ...item, estimate_point: newEstimatePoint }
  //         : item
  //     )
  //   );
  // };

  console.log("dataEvaluationForm", dataEvaluationForm);
  const handleRadioChange = (
    detailId: number,
    subDetailId: number,
    value: string
  ) => {
    console.log("detailId", detailId);
    console.log("subDetailId", subDetailId);

    setSelectedValues((prevValues: any) => {
      const updatedAdvisorEstimateDetail =
        prevValues.advisor_estimate_detail.map((item: any) =>
          item.id_advisor_form_detail === detailId &&
          item.id_advisor_form_detail_sub === subDetailId
            ? { ...item, estimate_point: value } // Update estimate_point with new value
            : item
        );

      return {
        ...prevValues,
        advisor_estimate_detail: updatedAdvisorEstimateDetail,
      };
    });

    console.log(
      "Updated advisor_estimate_detail",
      selectedValues?.advisor_estimate_detail.filter(
        (x: any) => x.id_advisor_form_detail_sub === subDetailId
      )
    );

    // Optionally, update the estimate point if necessary
    // updateEstimatePoint(subDetailId, value); // Assuming you want to sync it
  };

  const handleUpdateStatus = async (id: number, prevData: any) => {
    if (profile && id) {
      try {
        const bodyJson = {
          ...prevData,
          last_updated_by: "student",
          status: "success",
        };

        const newBody = {
          advisor_student_detaill: JSON.stringify(bodyJson),
        };

        const response = await advisorStudentApi.updateAdvisorStudent(
          +id,
          newBody
        );

        if (response.status < 300) {
          alertSuccess(
            t("จบการขอคำปรึกษา"),
            t("จบการขอคำปรึกษา เรียบร้อบแล้ว"),
            undefined,
            () => {
              navigate(routeName.student.studentConsultation + `/${id}/update`);
            }
          );
        } else {
          alertError(t("จบการขอคำปรึกษา ไม่สำเร็จ"));
        }
      } catch (error) {
        alertError(t("จบการขอคำปรึกษา ไม่สำเร็จ"));
      } finally {
        dispatch(unsetLoading());
      }
    } else {
      alertError(t("ข้อมูลไม่ครบถ้วน"));
    }
  };

  return (
    <Card>
      {/* Header Section with color, extra content, and toggle button */}
      <Box
        sx={{
          backgroundColor: colors.success3,
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 16px",
        }}
      >
        <Typography variant="h6" sx={{ color: "white" }}>
          {t("คะแนนการให้คำปรึกษา และผลสรุปของการแก้ปัญหา")}
        </Typography>

        {/* Extra content with arrow icons */}
        <IconButton onClick={handleToggleContent} sx={{ color: "white" }}>
          {isContentVisible ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {/* Collapse component for animation transition */}
      <Collapse in={isContentVisible} timeout="auto" unmountOnExit>
        <Box
          ref={chatContainerRef} // Attach reference here
          sx={{
            paddingTop: "25px",
            paddingLeft: isAll && isAll ? "10%" : "20%",
            paddingRight: isAll && isAll ? "10%" : "20%",
            minHeight: isAll && isAll ? "100%" : "500px",
            maxHeight: isAll && isAll ? "100%" : "500px",
            paddingBottom: isAll && isAll ? "300px" : "12px",
            overflowY: "auto",
          }}
        >
          {dataEvaluationForm &&
            dataEvaluationForm.map((detail: any) => (
              <div key={detail.id_advisor_form_detail}>
                {/* Main Title */}
                <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mb-4">
                  <Card
                    sx={{
                      boxShadow: `0px 5px ${colors.subPrimary}`,
                      padding: 2,
                      flexDirection: "row",
                      borderRadius: "12px",
                      border: "1px solid #E0E0E0",
                    }}
                  >
                    <Typography variant="h4">
                      {detail.advisor_form_detail_name}
                    </Typography>
                  </Card>
                </article>

                {/* Sub Titles and Radio Selections */}
                {detail.advisor_form_detail_sub.map((subDetail: any) => {
                  // Get the selected estimate_point value from selectedValues for this subDetail
                  const selectedEstimatePoint =
                    selectedValues?.advisor_estimate_detail?.find(
                      (item: any) =>
                        item.id_advisor_form_detail ===
                          detail.id_advisor_form_detail &&
                        item.id_advisor_form_detail_sub ===
                          subDetail.id_advisor_form_detail_sub
                    )?.estimate_point || "";

                  return (
                    <article
                      className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-8 mb-8"
                      key={subDetail.id_advisor_form_detail_sub}
                    >
                      <Card
                        sx={{
                          boxShadow: `0px 5px ${colors.subPrimary}`,
                          padding: 2,
                          flexDirection: "row",
                          borderRadius: "12px",
                          border: "1px solid #E0E0E0",
                        }}
                      >
                        <Typography variant="h4">
                          {subDetail.advisor_form_detail_sub_name}
                        </Typography>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            marginTop: "16px",
                            justifyContent: "start",
                            alignItems: "center",
                          }}
                        >
                          <RadioCustom
                            value={selectedEstimatePoint}
                            onChange={(e: any) =>
                              handleRadioChange(
                                detail.id_advisor_form_detail,
                                subDetail.id_advisor_form_detail_sub,
                                e.target.value
                              )
                            }
                            heading={t("ตัวเลือก")}
                            sx={{ my: 1 }}
                            dataList={dataChoices.map((choice) => ({ ...choice, label: t(choice.label) }))}
                            disabled
                          />
                        </div>
                      </Card>
                    </article>
                  );
                })}
              </div>
            ))}

          <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mb-12">
            <InputTextField
              disabled
              heading={t("ผลสรุปของการแก้ปัญหา")}
              placeholder={t("ระบุผลสรุปของการแก้ปัญหา")}
              value={remark ?? ""}
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
            />
          </article>
        </Box>
      </Collapse>
    </Card>
  );
};

export default VotingEvaluation;
